export default __webpack_public_path__ + "static/media/029-analysis.c83297c1.svg";